import React from 'react';
import ScreenComponent from './ScreenComponent';
import axios from 'axios';
import { config } from '../../app/config';
import { connect } from "react-redux";
import { preloaderShow, preloaderHide, alert, topbarUpdate, openLink } from '../../actions';
import '../../styles/elements/screen.scss';
import '../../styles/screens/knowledge-base.scss';
import TranslationService from "../../app/services/TranslationService";
import {Markdown} from "./knowledge-base/file/Markdown";
import {Button} from "../icymat-design/Button";
import {FormGroup} from "../icymat-design/FormGroup";


class KnowledgeBaseClass extends ScreenComponent
{
    constructor(props)
    {
        super(props);

        this.state = {
            path: '/',
            directories: [],
            directory: null,
            files: [],
            file: null,
            newFile: false,
            newFileName: ''
        };
    };

    getScreenName() {
        return 'knowledge-base';
    };

    componentDidUpdate = (prevProps, prevState) => {
        if (prevProps.view !== this.getScreenName() && this.props.view === this.getScreenName()) {
            this.loadData(this.state.book_id);
            this.props.topbarUpdate({
                action1: null,
                action2: null,
                actionBig: this.getBigActions()
            });

            this.openElementFromLink();
        }
    };

    openElementFromLink = () => {
        // if (this.props.link !== null) {
        //     const noteToOpen = this.props.link;
        //     this.props.openLink(null);
        //     this.openNote(noteToOpen, true);
        // }
    }

    getBigActions = () => {
        return [
            {
                'type': 'button',
                'color': 'main',
                'secondary': true,
                'icon': 'imd-icon imd-icon-new-tab',
                'text': null,
                'onClick': () => this.setState({newFile: !this.state.newFile})
            }
        ];
    }

    loadData = (bookId = null) => {
        this.props.preloaderShow();
        let that = this;

        axios.get(config.apiAddress + '/knowledge-base')
            .then(function (response) {
                that.setState({path: response.data.path, directories: response.data.directories, directory: null, files: response.data.files, file: null});
                that.props.preloaderHide();
            }).catch(function(error) {
                that.props.alert(TranslationService.trans(that.props.language, 'common.error'));
                that.props.preloaderHide();
            });
    };

    renderDirectories = () => {
        const rows = [];
        const that = this;

        if (this.state.directory !== null) {
            rows.push(<tr key={'dir-parent'} onClick={() => {that.openDirectory(this.state.directory.parent)}}>
                <td>
                    <span className={'imd-icon imd-icon-folder'} /> ..
                </td>
            </tr>);
        }

        this.state.directories.forEach((dir, key) => {
            rows.push(<tr key={'dir-' + key} onClick={() => {that.openDirectory(dir)}}>
                <td>
                    <span className={'imd-icon imd-icon-folder'} /> {dir.name}
                </td>
            </tr>);
        });

        return rows;
    }

    renderFiles = () => {
        const rows = [];
        const that = this;

        this.state.files.forEach((file, key) => {
            rows.push(<tr key={'file-' + key} onClick={() => {that.openFile(file.id)}}>
                <td>
                    {that.getIcon(file.name)} {file.name}
                </td>
            </tr>);
        });

        return rows;
    }

    getIcon = (name) => {
        const extension = name.split('.').pop().toLowerCase();

        switch (extension) {
            case 'md':
                return <span className={'imd-icon imd-icon-doc-star'} />;
            default:
                return <span className={'imd-icon imd-icon-help-square'} />;
        }
    }

    openDirectory = (directory = null) => {
        this.props.preloaderShow();
        let that = this;

        console.log('Opening directory', directory);

        axios.get(config.apiAddress + '/knowledge-base?directory=' + (directory ? directory.id : ''))
            .then(function (response) {
                that.setState({path: response.data.path, directories: response.data.directories, directory: directory, files: response.data.files});
                that.props.preloaderHide();
            }).catch(function(error) {
                that.props.alert(TranslationService.trans(that.props.language, 'common.error'));
                that.props.preloaderHide();
            });
    };

    createFile = () => {
        if (this.state.newFileName.trim() === '') {
            return;
        }

        this.props.preloaderShow();
        const that = this;

        axios.post(
            config.apiAddress + '/knowledge-base/file?directory=' + (this.state.directory ? this.state.directory.id : ''),
            {name: this.state.newFileName.trim()}
        )
            .then(function (response) {
                that.props.preloaderHide();
                that.setState({newFile: false, newFileName: ''});
                that.openDirectory(that.state.directory);
            }).catch(function(error) {
                that.props.alert(TranslationService.trans(that.props.language, 'common.error'));
                that.props.preloaderHide();
            });
    }

    openFile = (fileId) => {
        this.props.preloaderShow();
        const that = this;

        axios.get(config.apiAddress + '/knowledge-base/file/' + fileId)
            .then(function (response) {
                that.setState({file: response.data});
                that.props.preloaderHide();

                that.props.topbarUpdate({
                    action1: null,
                    action2: null,
                    actionBig: null
                });
            }).catch(function(error) {
                that.props.alert(TranslationService.trans(that.props.language, 'common.error'));
                that.props.preloaderHide();
            });
    }

    closeFile = () => {
        this.setState({file: null});
        this.props.topbarUpdate({
            action1: null,
            action2: null,
            actionBig: this.getBigActions()
        });
    }

    saveFile = (fileId, content, autoClose = false) => {
        this.props.preloaderShow();
        const that = this;

        axios.put(config.apiAddress + '/knowledge-base/file/' + fileId, {content: content})
            .then(function (response) {
                that.props.preloaderHide();

                if (autoClose) {
                    that.closeFile();
                }
            }).catch(function(error) {
                that.props.alert(TranslationService.trans(that.props.language, 'common.error'));
                that.props.preloaderHide();
            });
    }

    render() {
        return (
            <div className="screen knowledge-base" id="screen-knowledge-base" style={this.getStyle()}>
                <div className="content imd-text-accent">
                    <div className="imd-container-fluid">
                        <div className="imd-row">
                            <div className="imd-col">
                                <h1 className={'imd-text-main'}>Baza wiedzy</h1>
                                <h2>{this.state.path}</h2>

                                <div className={'imd-table-responsive'} style={{display: this.state.file === null ? 'block' : 'none'}}>
                                    <table className={'imd-table imd-table-hovered files'}>
                                        <thead>
                                            <tr>
                                                <th>{TranslationService.trans(this.props.language, 'common.name')}</th>
                                            </tr>
                                        </thead>

                                        <tbody>
                                            {this.renderDirectories()}
                                            {this.renderFiles()}
                                        </tbody>
                                    </table>
                                </div>

                                {
                                    this.state.file !== null && this.state.file.extension === 'md' ?
                                        <Markdown
                                            file={this.state.file}
                                            language={this.props.language}
                                            saveFile={(fileId, content, autoClose) => {this.saveFile(fileId, content, autoClose)}}
                                        /> :
                                        null
                                }
                            </div>
                        </div>
                    </div>
                </div>

                <dialog className={'imd-dialog imd-dialog-sm imd-bg-blur-black' + (this.state.newFile ? ' imd-opened' : '')}>
                    <div className="imd-dialog-body imd-bg-20-default imd-text-accent">
                        <div className="imd-dialog-content">
                            <label>
                                <FormGroup
                                    value={this.state.newFileName}
                                    onChange={e => {this.setState({newFileName: e.target.value})}}
                                    suffix={'.md'}
                                />
                            </label>
                        </div>

                        <footer>
                            <Button
                                color={'accent'}
                                secondary={true}
                                text={TranslationService.trans(this.props.language, 'common.cancel')}
                                onClick={() => this.setState({newFile: false})}
                            />
                            <Button
                                color={'main'}
                                text={TranslationService.trans(this.props.language, 'common.create')}
                                onClick={() => this.createFile()}
                            />
                        </footer>
                    </div>
                </dialog>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        view: state.view,
        language: TranslationService.getLanguage(state.user),
        link: state.link
    }
};

export const KnowledgeBaseScreen = connect(mapStateToProps, {preloaderShow, preloaderHide, alert, topbarUpdate, openLink})(KnowledgeBaseClass);
